import { useMutation } from "react-query";
import { updateEmployeeBilingual } from "../../../../../actions/Utilities/EmployeeBilingual";

const useEditEmployeeBilingual = () => {
  return useMutation(updateEmployeeBilingual);
};

export default useEditEmployeeBilingual;
